import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import Button from '../elements/Button';

const propTypes = {
  ...SectionSplitProps.types
}

const defaultProps = {
  ...SectionSplitProps.defaults
}

class CloudTransformation extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      invertMobile,
      invertDesktop,
      alignTop,
      imageFill,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'cloud-transformation section',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'cloud-transformation-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const splitClasses = classNames(
      'split-wrap',
      invertMobile && 'invert-mobile',
      invertDesktop && 'invert-desktop',
      alignTop && 'align-top'
    );

    const sectionHeader = {
      title: 'Cloud Transformation Services',
      paragraph: 'Transform your local software infrastructure to the cloud. We help companies migrate from on-premise solutions to modern, scalable cloud-based systems powered by Microsoft Azure.'
    };

    return (
      <section
        {...props}
        id="cloud-transformation"
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content invert-color" />
            <div className={splitClasses}>
              <div className="split-item">
                <div className="split-item-content center-content-mobile reveal-from-left" data-reveal-container=".split-item">
                  <h3 className="mt-0 mb-16">
                    From Local to Cloud: Seamless Migration
                  </h3>
                  <p className="m-0 mb-24">
                    Many companies still rely on local, on-premise software solutions that limit scalability, accessibility, and efficiency. Our cloud transformation services help you modernize your infrastructure by migrating your existing local software to the cloud.
                  </p>
                  <p className="m-0 mb-24">
                    We understand the challenges of transitioning from local systems—data migration, downtime concerns, and user training. Our proven methodology ensures a smooth, phased approach that minimizes disruption to your operations.
                  </p>
                  <ul className="list-reset text-sm mb-32">
                    <li className="mb-8">✓ Assessment of your current local software infrastructure</li>
                    <li className="mb-8">✓ Custom migration strategy tailored to your needs</li>
                    <li className="mb-8">✓ Data migration with zero data loss guarantee</li>
                    <li className="mb-8">✓ Azure cloud deployment and optimization</li>
                    <li className="mb-8">✓ Staff training and change management support</li>
                    <li className="mb-8">✓ Ongoing support and maintenance</li>
                  </ul>
                  <div className="reveal-from-bottom" data-reveal-delay="200" data-reveal-container=".split-item">
                    <Button tag="a" color="primary" href="#/" onClick={(e) => { e.preventDefault(); if (window.location.hash !== '#/') window.location.hash = '#/'; setTimeout(() => { const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 100); }} wideMobile>
                      Start Your Cloud Transformation
                    </Button>
                  </div>
                </div>
                <div className={
                  classNames(
                    'split-item-image center-content-mobile reveal-scale-up',
                    imageFill && 'split-item-image-fill'
                  )}
                  data-reveal-container=".split-item"
                  data-reveal-delay="300">
                  <div style={{
                    borderRadius: '24px',
                    overflow: 'hidden',
                    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1)',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    transform: 'translateY(0)',
                    position: 'relative'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    e.currentTarget.style.boxShadow = '0 30px 80px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 20px 60px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1)';
                  }}>
                    <Image
                      src="/cloud.jpg"
                      alt="Cloud Transformation - Technical Infrastructure"
                      width={896}
                      height={504}
                      style={{
                        display: 'block',
                        width: '100%',
                        height: 'auto',
                        borderRadius: '24px'
                      }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="tiles-wrap" style={{ marginTop: '48px' }}>
              <div className="tiles-item reveal-from-bottom">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      Infrastructure Assessment
                    </h4>
                    <p className="m-0 text-sm">
                      We conduct a comprehensive analysis of your current local software setup to identify migration requirements, dependencies, and potential challenges.
                    </p>
                  </div>
                </div>
              </div>
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="100">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      Phased Migration
                    </h4>
                    <p className="m-0 text-sm">
                      Our phased approach ensures minimal business disruption. We migrate systems incrementally, allowing you to maintain operations throughout the process.
                    </p>
                  </div>
                </div>
              </div>
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      Azure Cloud Deployment
                    </h4>
                    <p className="m-0 text-sm">
                      Your software runs on Microsoft Azure's robust cloud infrastructure, providing scalability, security, and reliability that local systems can't match.
                    </p>
                  </div>
                </div>
              </div>
              <div className="tiles-item reveal-from-bottom" data-reveal-delay="300">
                <div className="tiles-item-inner">
                  <div className="features-tiles-item-content">
                    <h4 className="mt-0 mb-8">
                      Continuous Support
                    </h4>
                    <p className="m-0 text-sm">
                      Post-migration support ensures your cloud infrastructure runs smoothly. We provide monitoring, optimization, and troubleshooting services.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

CloudTransformation.propTypes = propTypes;
CloudTransformation.defaultProps = defaultProps;

export default CloudTransformation;
